var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:(_vm.description),expression:"description",modifiers:{"hover":true}}],staticClass:"status",attrs:{"data-status":_vm.cooperationStatus}},[_c('i',{staticClass:"fas fa-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }